"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
var React = require("react");
var Tile_style_1 = require("./Tile.style");
var Icon_1 = require("../../Icon");
var Popup_1 = require("../Popup");
var Button_1 = require("../../Button");
exports.Tile = function (props) {
    var _a = React.useState(false), showPopup = _a[0], setPopup = _a[1];
    var title = props.title, icon = props.icon, description = props.description, buttonText = props.buttonText, onButtonClick = props.onButtonClick, isDesktop = props.isDesktop, imageUrl = props.imageUrl, isPopup = props.isPopup, children = props.children, bgPosition = props.bgPosition, theme = props.theme, type = props.type, coins = props.coins, disabled = props.disabled, disclaimer = props.disclaimer, style = props.style;
    var setButton = function () {
        if (isPopup) {
            return setPopup(!showPopup);
        }
        if (onButtonClick) {
            onButtonClick();
        }
    };
    return type === "featured" ? (React.createElement(Tile_style_1.default.Wrap, { isDesktop: isDesktop },
        React.createElement(Tile_style_1.default.ImgWrap, { bgPosition: bgPosition || null, imageUrl: imageUrl }),
        React.createElement(Tile_style_1.default.Content, null,
            React.createElement(Tile_style_1.default.Title, { style: { minHeight: "auto", fontSize: isDesktop ? "26px" : "24px" } }, title),
            React.createElement(Tile_style_1.default.Description, null, description),
            React.createElement("div", { style: { margin: "24px 0" } },
                React.createElement(Icon_1.default, { icon: "coins", size: 40 }),
                " ",
                React.createElement("span", { style: { fontWeight: 600 } },
                    "X",
                    coins,
                    " coins")),
            React.createElement(Button_1.default, { onClick: function () { return setButton(); }, style: { maxWidth: "200px" } }, buttonText)),
        isPopup ? (React.createElement(Popup_1.default, { open: showPopup, isDesktop: isDesktop, handleClick: setPopup }, children)) : null)) : (React.createElement(Tile_style_1.default.Wrap, { isDesktop: isDesktop, style: style, theme: theme },
        React.createElement(Tile_style_1.default.ImgWrap, { bgPosition: bgPosition || null, imageUrl: imageUrl }),
        React.createElement(Tile_style_1.default.Content, null,
            React.createElement(Tile_style_1.default.Title, { style: {
                    fontSize: "26px",
                    color: theme === "darkTheme" ? "white" : "auto",
                } }, theme === "greenTheme" ? (React.createElement("span", null,
                "MySh",
                React.createElement(Icon_1.default, { icon: "leaf", size: 18, colorPrimary: "#86B049" }),
                "p")) : (title)),
            React.createElement(Tile_style_1.default.Description, { style: {
                    color: theme === "darkTheme" ? "white" : "auto",
                } }, description),
            buttonText ? (React.createElement(Tile_style_1.default.Button, { disabled: disabled, onClick: function () { return setButton(); } },
                icon ? (React.createElement(Icon_1.default, { icon: icon, size: 40, style: { marginRight: "8px" } })) : null,
                buttonText)) : null,
            disclaimer ? (React.createElement(Tile_style_1.default.Disclaimer, null,
                React.createElement("i", null, children))) : null),
        isPopup ? (React.createElement(Popup_1.default, { open: showPopup, isDesktop: isDesktop, handleClick: setPopup }, children)) : null));
};
exports.default = exports.Tile;
//# sourceMappingURL=Tile.js.map